import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "redux"
import MasterPopups from "./MasterPopups"

const mapStateToProps = (state, props) => ({
	mLocIds: state.mLocIdSecondarySelections,
})

const mapDispatchToProps = (dispatch) => ({})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(MasterPopups)
